import {AboutContainer,AboutGrid,AboutSection} from './styles';

import { DataAbout } from '../DataAbout';
import { ProfileAbout } from '../ProfileAbout';


export function About(){
    return (
        <AboutSection id="about">
            <AboutContainer>
                <h2>Sobre</h2>
                <p>Conheça um pouco da minha história</p>
                <AboutGrid>
                    <ProfileAbout/>
                    <div>
                        <DataAbout/>
                        <p>
                            Desenvolvedor Front End com especialização em ReactJS e 
                            mais de 5 (cinco) anos de experiência com desenvolvimento web. Acredito que a 
                            tecnologia é o presente e o futuro das novas soluções de mercado.
                        </p>
                        <a download="" href="./assets/Jonas-CV.pdf">
                            Baixar Currículo
                            <i className="uil uil-file-download-alt"></i>
                        </a>
                    </div>
                </AboutGrid>
            </AboutContainer>
        </AboutSection>
    )
}